<template>
  <div style="text-align: center">
    <span
      v-for="(color, key) in labels"
      :key="key"
      :style="{
        color: noColor ? null : color[0],
        backgroundColor: noColor ? null : color[1]
      }"
      :class="{ 'no-color': noColor, selected: selected === key }"
      class="label hand"
      @click="select(key)"
      >{{ key }}
    </span>
  </div>
</template>

<script>
import { docs } from "@/db";
export default {
  name: "HiLabels",
  props: {
    type: {
      type: String
    },
    noColor: {
      type: Boolean
    }
  },
  data() {
    return {
      labels: [],
      selected: null
    };
  },
  firestore() {
    return {
      labels: docs.labels[this.type]
    };
  },
  methods: {
    select(key) {
      console.log(key);
      if (key === this.selected) return;
      this.selected = key;
      this.$emit("select", key);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.no-color {
  color: white;
  background-color: #474643;
}
.selected.no-color {
  background-color: $gold-dark;
}

.label {
  opacity: 0.4;
}
.no-color :hover {
  background-color: $gold-hover;
}
.label.selected {
  opacity: 1;
  cursor: default;
}
</style>
